export const getManager = async (currentManagerId: number) => {
    //@ts-ignore
    const getManagerUrl = helpable.replaceUrlParameters(routable.getRoute('getManager'), {
        //@ts-ignore
        _managerId_: currentManagerId,
    });

    try {
        const getManagerInfo = await fetch(getManagerUrl, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!getManagerInfo.ok) {
            const error = await getManagerInfo.json();

            //@ts-ignore
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('swal.button.text.ok'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            throw new Error(error.message);
        }

        const { data } = await getManagerInfo.json();
        return { ...data };
    } catch (error) {
        throw error;
    }
};
